import { REACT_APP_API } from '../../config'
import axios from 'axios'

export async function putCustomFilters(customFilters) {
    try {
        const response = await axios.put(`${REACT_APP_API}/custom_filters`, customFilters)
        return response.data
    } catch (error) {
        throw new Error(error)
    }
}